/** Filtres année + mois calendaire en cours (planning newsletter / web). */
export const getDefaultPlanningMonthFilters = () => {
  const now = new Date();
  return {
    annee: now.getFullYear(),
    mois: [String(now.getMonth() + 1)],
  };
};

/** Une seule valeur pour l’API ; '' = tous (0 ou >1 sélections). */
export const singleOrEmpty = (values) => (
  Array.isArray(values) && values.length === 1 ? String(values[0]) : ''
);

/** Plusieurs valeurs pour l’API (csv) ; '' = tous. */
export const joinOrEmpty = (values) => {
  if (!Array.isArray(values) || values.length === 0) return '';
  return values.map(String).filter(Boolean).join(',');
};

/** Première valeur sélectionnée, sinon fallback. */
export const firstOrFallback = (values, fallback = '') => {
  if (Array.isArray(values) && values.length > 0 && values[0] != null && String(values[0]).trim() !== '') {
    return String(values[0]);
  }
  return fallback;
};

/** Options d’années pour les filtres MAG / SET (N-1 → N+1). */
export const buildYearFilterOptions = (selected = []) => {
  const current = new Date().getFullYear();
  const minYear = current - 1;
  const maxYear = current + 1;
  const years = new Set();
  for (let year = minYear; year <= maxYear; year += 1) {
    years.add(year);
  }
  (Array.isArray(selected) ? selected : [selected]).forEach((item) => {
    const year = Number(item);
    if (Number.isFinite(year) && year >= minYear && year <= maxYear) {
      years.add(year);
    }
  });
  return [...years]
    .sort((a, b) => a - b)
    .map((year) => ({ value: String(year), label: String(year) }));
};

/**
 * Filet de sécurité : ne garde que les lignes des valeurs cochées.
 * Une seule valeur compte aussi : une réponse arrivée en retard (sans ce filtre)
 * ne doit pas réafficher les autres mois.
 */
export const filterRowsByMulti = (rows, selected, getValue) => {
  if (!Array.isArray(selected) || selected.length === 0) return rows;
  const set = new Set(selected.map((value) => String(value)));
  return (Array.isArray(rows) ? rows : []).filter((row) => set.has(String(getValue(row) ?? '')));
};
